import axios from 'axios';

const sitecoreAxios = axios.create();
const deferredRequests = /* @__PURE__ */ new Set();
const deferringInterceptor = sitecoreAxios.interceptors.request.use(
  (config) => {
    return new Promise((resolve) => {
      deferredRequests.add((middleware) => resolve(middleware(config)));
    });
  }
);
function applyAuthzInterceptor(authz) {
  sitecoreAxios.interceptors.request.eject(deferringInterceptor);
  sitecoreAxios.interceptors.request.use(applyConfig);
  deferredRequests.forEach((cb) => cb(applyConfig));
  function applyConfig(config) {
    config.headers["X-PM2-Authentication-Type"] = authz.authenticationProvider;
    config.headers["X-PM2-Authorized"] = String(authz.isAuthorized);
    config.headers["X-PM2-User-Role"] = authz.userRole;
    return config;
  }
}
function applyPreviewInterceptor() {
  sitecoreAxios.interceptors.request.use((config) => {
    var _a;
    config.url = (_a = config.url) == null ? void 0 : _a.replace(
      process.env["PM2_API"] ?? "",
      process.env["PM2_PREVIEW_API"] ?? ""
    );
    return config;
  });
}
function applySiteCoreSigningInterceptor(buildSignature) {
  sitecoreAxios.interceptors.request.use((config) => {
    const { signature, tstamp } = buildSignature({
      url: config.url ?? "",
      authz: {
        isAuthorized: !!config.headers["X-PM2-Authorized"],
        authenticationProvider: config.headers["X-PM2-Authentication-Type"] ?? "",
        userRole: config.headers["X-PM2-User-Role"]
      }
    });
    config.headers["Authorization"] = signature;
    config.headers["X-PM2-Authenticated-At"] = tstamp;
    return config;
  });
}

export { applyAuthzInterceptor, applyPreviewInterceptor, applySiteCoreSigningInterceptor, sitecoreAxios };
//# sourceMappingURL=core.axios.js.map
